module.exports = __webpack_public_path__ + "static/img/14.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/14.png
// module id = eDk5
// module chunks = 0